function getMappingInfos() {
  try {
    const pageMappingInfos = [
      {
        pageName: 'ContentPage',
        pageRegex: /\/content(\?.*)?/,
        keyEntryRegexs: [],
        loadedFunc: () => {
          const loader = document.querySelector(
            '.Content-tableBody.Table-body .Loading-cells-placeholder',
          );
          const tableContainer = document.querySelector(
            '.Content-tableBody.Table-body .Table-row',
          );
          const emptyContainer = document.querySelector(
            '.LoadableState  .Index-blankSlate',
          );
          // Check if the page container already exists without the loader, return true immediately
          if (!loader && (tableContainer || emptyContainer)) {
            return true;
          }
          return false;
        },
      },
      {
        pageName: 'EventsPage',
        pageRegex: /\/in_person_training\/events(\?.*)?/,
        keyEntryRegexs: [],
        loadedFunc: () => {
          const loader = document.querySelector(
            '.Content-tableBody.Table-body .Loading-cells-placeholder',
          );
          const tableContainer = document.querySelector(
            '.Content-tableBody.Table-body .Table-row',
          );
          const emptyContainer = document.querySelector(
            '.LoadableState  .Index-blankSlate',
          );
          if (!loader && (tableContainer || emptyContainer)) {
            return true;
          }
          return false;
        },
      },
      {
        pageName: 'PeoplePage',
        pageRegex: /\/people(\?.*)?/,
        keyEntryRegexs: [],
        loadedFunc: () => {
          const loader = document.querySelector(
            '.Content-tableBody.Table-body .Loading-cells-placeholder',
          );
          const tableContainer = document.querySelector(
            '.Content-tableBody.Table-body .Table-row',
          );
          const emptyContainer = document.querySelector(
            '.LoadableState  .Index-blankSlate',
          );
          if (!loader && (tableContainer || emptyContainer)) {
            return true;
          }
          return false;
        },
      },
      {
        pageName: 'LearnPage',
        pageRegex: /\/learn(\/)?$/,
        keyEntryRegexs: [],
        loadedFunc: () => {
          const loader = document.querySelector(
            '.LearnDashboard-main .Spinner',
          );
          const dataContainer = document.querySelector(
            '.LearnDashboard-content .ContentGroup-contents .LearnContentCard',
          );
          const emptyContainer = document.querySelector(
            '.LearnDashboard-main .NewBlankSlate',
          );
          if (!loader && (dataContainer || emptyContainer)) {
            return true;
          }
          return false;
        },
      },
      {
        pageName: 'UserDetailsPage',
        pageRegex: /\/users\/[0-9]*/,
        keyEntryRegexs: [],
        loadedFunc: () => {
          const dataContainer = document.querySelector('.AssignmentSummary');
          const emptyContainer = document.querySelector('.blank_slate');
          if (dataContainer || emptyContainer) {
            return true;
          }
          return false;
        },
      },
      {
        pageName: 'LessonPage',
        pageRegex: /\/lesson\/.*(\?.*)?/,
        keyEntryRegexs: [],
        loadedFunc: () => {
          const loader = document.querySelector('.react-loading-skeleton');
          const dataContainer = document.querySelector('.lesson_section');
          const seismicElementLoader =
            document.querySelector('.ElementLoading');
          const elementLoadingSpinner = document.querySelector('.up-spinner');
          const seismicPlayer = document.querySelector('.SeismicPlayer');
          const upSeismicPlayer = document.querySelector('.up-seismic-player');
          if (
            !loader &&
            !seismicElementLoader &&
            !elementLoadingSpinner &&
            dataContainer &&
            !seismicPlayer
          ) {
            return true;
          }
          if (
            seismicPlayer &&
            !seismicElementLoader &&
            !elementLoadingSpinner &&
            dataContainer &&
            upSeismicPlayer
          ) {
            return true;
          }

          return false;
        },
      },
    ];
    return pageMappingInfos;
  } catch (error) {
    console.error('pfe monitor ', 'getMappingInfos', error);
  }
  return [];
}

export default { getMappingInfos };
